import { useEffect, useState } from "react";
import { KioskCanvas } from "@/components/KioskCanvas";
import { Viewport, getViewportPreset } from "@/components/Viewport";
import { fontStyleToCss } from "@/lib/kioskGrid";

/**
 * Live editor preview. Renders the welcome screen directly from the current draft
 * config using the SAME renderer as the live kiosk (KioskCanvas), inside a scaled
 * device Viewport. Updates instantly as controls change — never waits for autosave.
 * All interactions are inert; clicking a major element calls `onFocus(key)`.
 *
 * `viewport` only affects the preview; publishing is unaffected.
 */
export function KioskPreview({ cfg, onFocus, viewport = "ipad_landscape", maxHeight = 620, defaultLogo = "" }) {
  const [now, setNow] = useState(new Date());
  const [idx, setIdx] = useState(0);
  const preset = getViewportPreset(viewport);

  useEffect(() => {
    const i = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(i);
  }, []);

  useEffect(() => {
    const evs = (cfg?.featured_events || []).filter((e) => e && e.visible !== false);
    if (!cfg?.carousel_mode || evs.length <= 1) return;
    const i = setInterval(() => setIdx((p) => (p + 1) % evs.length), 4000);
    return () => clearInterval(i);
  }, [cfg?.carousel_mode, cfg?.featured_events]);

  if (!cfg) return null;

  return (
    <Viewport
      width={preset.w}
      height={preset.h}
      maxHeight={maxHeight}
      frameClassName="rounded-2xl border border-[#E5E2DC]"
      data-testid="design-live-preview"
    >
      <div
        className="w-full h-full overflow-hidden kiosk-mode grain"
        style={{ backgroundColor: cfg.bg_color, ...fontStyleToCss(cfg.default_font) }}
        onClick={() => onFocus && onFocus("background")}
      >
        <KioskCanvas cfg={cfg} now={now} carouselIdx={idx} onFocus={onFocus} defaultLogo={defaultLogo} />
      </div>
    </Viewport>
  );
}
